<section class="legal-page">
  <div class="legal-title-strip">
    <h1>{{ appModeService.isApp() ? ('FOOTER.PRIVACY' | translate) : 'Privacy Policy' }}</h1>
  </div>

  <article class="legal-content" [innerHTML]="content"></article>

  <div class="legal-actions">
    <button class="read-more-btn" (click)="navigateToShop()">{{ 'VISIT_STORE' | translate }}</button>
  </div>
</section>
